module.exports = __webpack_public_path__ + "static/media/exceluploader.77aabc2d.png";